import { styled } from '@mui/material';
import { Icon, Stack, Text } from 'shell/components';

const IconDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Icon</Text>
            <Stack sx={{ flexFlow: 'row wrap' }} spacing={2}>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'add'} />
                    <Text variant={'p2'}>add</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'addPhoto'} />
                    <Text variant={'p2'}>addPhoto</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'ai'} />
                    <Text variant={'p2'}>ai</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'avatar'} />
                    <Text variant={'p2'}>avatar</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'announcement'} />
                    <Text variant={'p2'}>announcement</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'arrowDown'} />
                    <Text variant={'p2'}>arrowDown</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'arrowLeft'} />
                    <Text variant={'p2'}>arrowLeft</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'arrowRight'} />
                    <Text variant={'p2'}>arrowRight</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'arrowUp'} />
                    <Text variant={'p2'}>arrowUp</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'attach'} />
                    <Text variant={'p2'}>attach</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'avatar'} />
                    <Text variant={'p2'}>avatar</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'bell'} />
                    <Text variant={'p2'}>bell</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'bellOff'} />
                    <Text variant={'p2'}>bellOff</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'bold'} />
                    <Text variant={'p2'}>bold</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'bookmarkFilled'} />
                    <Text variant={'p2'}>bookmarkFilled</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'bookmarkOutlined'} />
                    <Text variant={'p2'}>bookmarkOutlined</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'calendar'} />
                    <Text variant={'p2'}>calendar</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'call'} />
                    <Text variant={'p2'}>call</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'callDisabled'} />
                    <Text variant={'p2'}>callDisabled</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'callIncoming'} />
                    <Text variant={'p2'}>callIncoming</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'callOutgoing'} />
                    <Text variant={'p2'}>callOutgoing</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'canada'} />
                    <Text variant={'p2'}>canada</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'channel'} />
                    <Text variant={'p2'}>channel</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'checkmark'} />
                    <Text variant={'p2'}>checkmark</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'chevronDown'} />
                    <Text variant={'p2'}>chevronDown</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'chevronLeft'} />
                    <Text variant={'p2'}>chevronLeft</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'chevronRight'} />
                    <Text variant={'p2'}>chevronRight</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'chevronUp'} />
                    <Text variant={'p2'}>chevronUp</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'clock'} />
                    <Text variant={'p2'}>clock</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'code'} />
                    <Text variant={'p2'}>code</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'column'} />
                    <Text variant={'p2'}>column</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'copy'} />
                    <Text variant={'p2'}>copy</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'dashboard'} />
                    <Text variant={'p2'}>dashboard</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'delete'} />
                    <Text variant={'p2'}>delete</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'download'} />
                    <Text variant={'p2'}>download</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'dropdownArrowDown'} />
                    <Text variant={'p2'}>dropdownArrowDown</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'dropdownArrowUp'} />
                    <Text variant={'p2'}>dropdownArrowUp</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'edit'} />
                    <Text variant={'p2'}>edit</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'email'} />
                    <Text variant={'p2'}>email</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'ensightful'} />
                    <Text variant={'p2'}>ensightful</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'error'} />
                    <Text variant={'p2'}>error</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'exit'} />
                    <Text variant={'p2'}>exit</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'favoriteEmpty'} />
                    <Text variant={'p2'}>favoriteEmpty</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'favoriteFilled'} />
                    <Text variant={'p2'}>favoriteFilled</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileCSV'} />
                    <Text variant={'p2'}>fileCSV</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileExcel'} />
                    <Text variant={'p2'}>fileExcel</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileHTML'} />
                    <Text variant={'p2'}>fileHTML</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileImg'} />
                    <Text variant={'p2'}>fileImg</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'filePDF'} />
                    <Text variant={'p2'}>filePDF</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'filePPT'} />
                    <Text variant={'p2'}>filePPT</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypeDoc'} />
                    <Text variant={'p2'}>fileTypeDoc</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypeGif'} />
                    <Text variant={'p2'}>fileTypeGif</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypeJpg'} />
                    <Text variant={'p2'}>fileTypeJpg</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypePdf'} />
                    <Text variant={'p2'}>fileTypePdf</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypePng'} />
                    <Text variant={'p2'}>fileTypePng</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypeSvg'} />
                    <Text variant={'p2'}>fileTypeSvg</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypeTxt'} />
                    <Text variant={'p2'}>fileTypeTxt</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypeUndefined'} />
                    <Text variant={'p2'}>fileTypeUndefined</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypeVideo'} />
                    <Text variant={'p2'}>fileTypeVideo</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileTypeZip'} />
                    <Text variant={'p2'}>fileTypeZip</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileUnknown'} />
                    <Text variant={'p2'}>fileUnknown</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileUploaded'} />
                    <Text variant={'p2'}>fileUploaded</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileWord'} />
                    <Text variant={'p2'}>fileWord</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fileZIP'} />
                    <Text variant={'p2'}>fileZIP</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'filter'} />
                    <Text variant={'p2'}>filter</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'folder'} />
                    <Text variant={'p2'}>folder</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'formatSelected'} />
                    <Text variant={'p2'}>formatSelected</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'formatDeselected'} />
                    <Text variant={'p2'}>formatDeselected</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fullScreenEnter'} />
                    <Text variant={'p2'}>fullScreenEnter</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'fullScreenExit'} />
                    <Text variant={'p2'}>fullScreenExit</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'gradientSparkle'} />
                    <Text variant={'p2'}>gradientSparkle</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'graphBarEmpty'} />
                    <Text variant={'p2'}>graphBarEmpty</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'graphPieEmpty'} />
                    <Text variant={'p2'}>graphPieEmpty</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'graphPieFilled'} />
                    <Text variant={'p2'}>graphPieFilled</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'hamburger'} />
                    <Text variant={'p2'}>hamburger</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'hashtag'} />
                    <Text variant={'p2'}>hashtag</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'help'} />
                    <Text variant={'p2'}>help</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'hide'} />
                    <Text variant={'p2'}>hide</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'home'} />
                    <Text variant={'p2'}>home</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'hugo'} />
                    <Text variant={'p2'}>hugo</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'info'} />
                    <Text variant={'p2'}>info</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'italic'} />
                    <Text variant={'p2'}>italic</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'link'} />
                    <Text variant={'p2'}>link</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'listOrdered'} />
                    <Text variant={'p2'}>listOrdered</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'listUnordered'} />
                    <Text variant={'p2'}>listUnordered</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'locationEmpty'} />
                    <Text variant={'p2'}>locationEmpty</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'locationFilled'} />
                    <Text variant={'p2'}>locationFilled</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'lock'} />
                    <Text variant={'p2'}>lock</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'logout'} />
                    <Text variant={'p2'}>logout</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'mentions'} />
                    <Text variant={'p2'}>mentions</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'message'} />
                    <Text variant={'p2'}>message</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'messageFilled'} />
                    <Text variant={'p2'}>messageFilled</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'messageRectangular'} />
                    <Text variant={'p2'}>messageRectangular</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'messageSparkle'} />
                    <Text variant={'p2'}>messageSparkle</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'mic'} />
                    <Text variant={'p2'}>mic</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'moreHorizontal'} />
                    <Text variant={'p2'}>moreHorizontal</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'move'} />
                    <Text variant={'p2'}>move</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'newComment'} />
                    <Text variant={'p2'}>newComment</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'pageJumpLeft'} />
                    <Text variant={'p2'}>pageJumpLeft</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'pageJumpRight'} />
                    <Text variant={'p2'}>pageJumpRight</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'pause'} />
                    <Text variant={'p2'}>pause</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'photo'} />
                    <Text variant={'p2'}>photo</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'play'} />
                    <Text variant={'p2'}>play</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'preview'} />
                    <Text variant={'p2'}>preview</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'randomize'} />
                    <Text variant={'p2'}>randomize</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'refresh'} />
                    <Text variant={'p2'}>refresh</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'remove'} />
                    <Text variant={'p2'}>remove</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'reorder'} />
                    <Text variant={'p2'}>reorder</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'reply'} />
                    <Text variant={'p2'}>reply</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'resync'} />
                    <Text variant={'p2'}>resync</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'save'} />
                    <Text variant={'p2'}>save</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'search'} />
                    <Text variant={'p2'}>search</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'send'} />
                    <Text variant={'p2'}>send</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'settings'} />
                    <Text variant={'p2'}>settings</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'sidebar'} />
                    <Text variant={'p2'}>sidebar</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'smile'} />
                    <Text variant={'p2'}>smile</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'sort'} />
                    <Text variant={'p2'}>sort</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'soundMuted'} />
                    <Text variant={'p2'}>soundMuted</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'starEmpty'} />
                    <Text variant={'p2'}>starEmpty</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'starFilled'} />
                    <Text variant={'p2'}>starFilled</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'stopWatch'} />
                    <Text variant={'p2'}>stopWatch</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'subtask'} />
                    <Text variant={'p2'}>subtask</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'subtract'} />
                    <Text variant={'p2'}>subtract</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'task'} />
                    <Text variant={'p2'}>task</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'taskBoard'} />
                    <Text variant={'p2'}>taskBoard</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'teams'} />
                    <Text variant={'p2'}>teams</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'textAlignLeft'} />
                    <Text variant={'p2'}>textAlignLeft</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'textAlignRight'} />
                    <Text variant={'p2'}>textAlignRight</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'thumbsDown'} />
                    <Text variant={'p2'}>thumbsDown</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'thumbsUp'} />
                    <Text variant={'p2'}>thumbsUp</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'tiltedSend'} />
                    <Text variant={'p2'}>tiltedSend</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'timeline'} />
                    <Text variant={'p2'}>timeline</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'underline'} />
                    <Text variant={'p2'}>underline</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'unlock'} />
                    <Text variant={'p2'}>unlock</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'upload'} />
                    <Text variant={'p2'}>upload</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'usa'} />
                    <Text variant={'p2'}>usa</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'video'} />
                    <Text variant={'p2'}>video</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'visible'} />
                    <Text variant={'p2'}>visible</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'web'} />
                    <Text variant={'p2'}>web</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'wrench'} />
                    <Text variant={'p2'}>wrench</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'zoomIn'} />
                    <Text variant={'p2'}>zoomIn</Text>
                </CustomStack>
                <CustomStack alignItems={'center'} spacing={2}>
                    <Icon kind={'zoomOut'} />
                    <Text variant={'p2'}>zoomOut</Text>
                </CustomStack>
            </Stack>
        </>
    );
};

const CustomStack = styled(Stack)(({ theme }) => ({
    border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
    borderRadius: '4px',
    padding: theme.spacing(2),
}));

export default IconDemo;
